import { V2Button, DownloadSimpleIcon } from "@stacklet/ui";

interface Props {
  handleExport: () => void;
  exportInProgress: boolean;
}

export function XGridCustomToolbarExport({
  handleExport,
  exportInProgress,
}: Props) {
  return (
    <V2Button
      IconLeft={<DownloadSimpleIcon size={20} />}
      aria-label="Export"
      isDisabled={exportInProgress}
      onPress={handleExport}
      variant="tertiary"
    >
      Export
    </V2Button>
  );
}
